import { Paper, Stack } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import { ClientDocumentDto, DocumentUploadConfigModel } from "types/generated/models";
import DocumentUpload from "./DocumentUpload";
import DocumentList from "../DocumentList";

export default function UploadedDocuments({
    documents,
    uploadConfig,
}: Readonly<{
    documents: ClientDocumentDto[];
    uploadConfig: DocumentUploadConfigModel;
}>) {
    return (
        <Paper data-test-id="section_uploaded_documents">
            <Stack spacing={4} p={3} pt={2}>
                {uploadConfig && <DocumentUpload config={uploadConfig} />}
                {documents.length > 0 && (
                    <Stack spacing={3} data-test-id="section_previously_uploaded_documents">
                        <Typography variant="paragraphExtraLargeSemiBold">Previously Uploaded Documents</Typography>
                        <DocumentList documents={documents} dataTestIdSuffix="uploaded" />
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
}
